import React from 'react';
import { Heading, List } from 'yoso';
import { HelpArticleModel, HelpCategoryModel } from '~/components/Help/Help.hooks';
import { HelpCategoryItem } from '~/components/Help/List/HelpCategoryItem';
import './HelpCategory.scss';

export type HelpCategoryProps = HelpCategoryModel;

export const HelpCategory = ({ categoryId, items, title, depth }: HelpCategoryProps) => (
  <div className="help-category">
    <Heading className="help-category-title" level={depth}>
      {title}
    </Heading>
    {items?.length > 0 && (
      <List className="help-category-list">
        {items.map((category, i) =>
          category.category ? (
            <HelpCategory key={i} {...(category as HelpCategoryModel)} categoryId={categoryId} />
          ) : (
            <HelpCategoryItem key={i} {...(category as HelpArticleModel)} categoryId={categoryId} />
          )
        )}
      </List>
    )}
  </div>
);
